<template>
  <div class="home-container">
    <div class="video-container">
      <video
        ref="videoRef"
        :src="videoUrl"
        :poster="require('@/assets/video_poster.jpg')"
        playsinline
        preload="metadata"
        @ended="onVideoEnded"
        @click.stop
        :class="{ 'paused': !isVideoPlaying }"
      ></video>
      
      <!-- 播放遮罩 -->
      <div 
        v-if="!isVideoPlaying" 
        class="play-overlay" 
        @click="playVideo"
      >
        <div class="play-button">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="48px" height="48px">
            <path d="M8 5v14l11-7z"/>
          </svg>
        </div>
      </div>
      
      <!-- <transition name="fade">
        <div v-show="showHomeContent" class="home-content" @click="GotoNavView"></div>
      </transition> -->
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const videoUrl = require('@/assets/start.mp4')
const videoRef = ref(null)
const showHomeContent = ref(false) // 控制home-content的显示

// @ is an alias to /src
const GotoNavView = async () => {
  // 尝试播放音乐
  if (window.playBgMusic && typeof window.playBgMusic === 'function') {
    await window.playBgMusic()
  }
  
  // 跳转到导航页面
  // router.push({
  //   path: '/nav',
  // })
}

// 视频播放状态
const isVideoPlaying = ref(false)

// 播放视频
const playVideo = () => {
  console.log('开始播放视频')
  if (videoRef.value) {
      videoRef.value.play();
      isVideoPlaying.value = true;
  }
}

// 视频播放结束时触发淡入效果
const onVideoEnded = () => {
  showHomeContent.value = true; // 显示home-content元素
  setTimeout( async () => {
    if (window.playBgMusic && typeof window.playBgMusic === 'function') {
    await window.playBgMusic()
  }
  
  router.push({
    path: '/nav',
  })
  }, 1500);
}

// 页面加载时设置初始状态
onMounted(() => {
  isVideoPlaying.value = false;
})

onMounted(() => {
  const el = videoRef.value
  // if (el) {
  //   el.muted = true
  //   el.play().catch(() => {})
  // }
})
</script>

<style lang="scss" scoped>
.home-container {
  background-image: url('../assets/home_bg.jpg');
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  position: relative; /* 关键：作为定位父级 */
  height: 100vh; /* 根据需求调整高度 */
  width: 100%; /* 根据需求调整宽度 */
  display: flex;
  flex-direction: column; /* 垂直排列 */
  padding-top: 459px;
  box-sizing: border-box;
  justify-content: flex-start; /* 确保子元素从顶部开始排列 */
  align-items: center; /* 水平居中对齐子元素 */
  position: relative;
  z-index: 121474836470;
}
.video-container{
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  @media screen and (min-width: 1024px){
        max-width: 677px !important;
        left: 50%;
        transform: translateX(-50%);
    }
}

.video-container video{
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: relative;
  
  &.paused {
    opacity: 0.8; /* 当视频暂停时稍微降低透明度 */
  }
}

.play-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: 
    linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
    url('@/assets/poster_video.jpg') center/cover no-repeat;
  z-index: 10;
  cursor: pointer;
}

.play-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.6);
  transition: all 0.3s ease;
}

.play-button:hover {
  background-color: rgba(0, 0, 0, 0.8);
  transform: scale(1.1);
}

.home-content{
  /* 设置背景图 */
  background-image: url('../assets/home_title.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 661px;
  height: 366px;
    /* 水平居中 */
  margin: 0 auto;
  position: absolute;
  left: 50%;
  top: 459px;
  transform: translateX(-50%);
  z-index: 2;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s ease-in-out;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
  transform: translateX(-50%) scale(0.9);
}
</style>
